(()=>{
  function bindMobileControlAutoHide(root){
    root.classList.remove('hfd-controls-collapsed');
  }

  function arrange(){
    const root=document.querySelector('[data-hfd]');
    if(!root)return;
    bindMobileControlAutoHide(root);

    const preview=root.querySelector('.hfd__preview-column');
    const scene=root.querySelector('.hfd__preview-stack')||root.querySelector('.hfd__scene');
    const sideGroup=root.querySelector('[data-side]')?.closest('.hfd__group');
    const modeButtons=root.querySelector('.hfd__mode-buttons');
    if(!preview||!scene||!sideGroup||!modeButtons)return;

    sideGroup.classList.add('hfd__side-above-preview');
    if(!window.matchMedia('(max-width:749px)').matches)root.classList.remove('hfd-controls-collapsed');
    if(preview.contains(sideGroup)&&root.querySelector('.hfd__sticky-preview'))return;

    if(window.matchMedia('(max-width:749px)').matches){
      let stickyPreview=preview.querySelector('.hfd__sticky-preview');
      if(!stickyPreview){
        stickyPreview=document.createElement('div');
        stickyPreview.className='hfd__sticky-preview';
        preview.insertBefore(stickyPreview,scene);
        stickyPreview.append(scene,modeButtons);
      }
      if(sideGroup.parentElement!==preview||sideGroup.nextElementSibling!==stickyPreview){
        preview.insertBefore(sideGroup,stickyPreview);
      }
      return;
    }

    root.classList.remove('hfd-controls-collapsed');
    const sticky=preview.querySelector('.hfd__sticky-preview');
    if(sticky){
      preview.insertBefore(scene,sticky);
      preview.insertBefore(modeButtons,sticky);
      sticky.remove();
    }

    if(sideGroup.parentElement!==preview||sideGroup.nextElementSibling!==scene){
      preview.insertBefore(sideGroup,scene);
    }
  }

  const run=()=>arrange();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
  window.addEventListener('resize',run);
})();
